import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

// Change the icons, function names, and parameters 
// to fit your portfolio topic and schema.

export const AddRecipePageTable = () => {

    const [title, setTitle]       = useState('');
    const [serves, setServes]         = useState('');
    const [date, setDate] = useState('');
    
    const redirect = useNavigate();

    const addRecipe = async () => {
        const newRecipe = { title, serves, date };
        const response = await fetch('/recipes', {
            method: 'post',
            body: JSON.stringify(newRecipe),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if(response.status === 201){
            alert(`The recipe ${title} was added to the collection.`);
        } else {
            alert(`There was a problem, and your recipe was not added to the collection. Please try again. Status code = ${response.status}`);
        }
        redirect("/RecipesPage");
    };


    return (
        <>
        <article>
            <h2>Add a recipe</h2>
            <p>Paragraph about this page.</p>
            
            <table id="recipes">
                <caption>Which recipe are you adding?</caption>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Serves</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                <td><label for="title">Recipe title</label>
                        <input
                            type="text"
                            placeholder="Title of the recipe"
                            value={title}
                            onChange={e => setTitle(e.target.value)} 
                            id="title" />
                    </td>

                    <td><label for="serves">Servings made</label>
                        <input
                            type="number"
                            value={serves}
                            placeholder="Servings"
                            onChange={e => setServes(e.target.value)} 
                            id="serves" />
                    </td>

                    <td><label for="date">Date</label>
                        <input
                            type="date"
                            placeholder="Date created"
                            value={date}
                            onChange={e => setDate(e.target.value)} 
                            id="date" />
                    </td>

                    <td>
                    <label for="submit">Enter</label>
                        <button
                            type="submit"
                            onClick={addRecipe}
                            id="submit"
                        >Add</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </article>
    </>
);
}

export default AddRecipePageTable;